import axios from 'axios'
import {BUSCAR_PEDIDOS_ITINEARIO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarPedidosItinerario(idEmpresa, idItinerario) {
    const url = `${URL}/pedido/empresa/${idEmpresa}/itinerario/${idItinerario}`
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_PEDIDOS_ITINEARIO,
            payload: response.data
        })
    )
}
